import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
//要设置的全局访问的state对象,赋予初始属性值
const state={
  typeid: 0,
  msgtotalcount: 0
}
//实时监听state值的变化(最新状态)
const getters = {
  getTypeid(state) {  //账户类型
    return state.typeid
  },
  getMsgtotalcount(state) {  //消息数量
    return state.msgtotalcount
  }
}
//自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象);
const mutations = {
  setTypeid(state,value){ //账户类型
    state.typeid = value;
  },
  setMsgtotalcount(state,value){ //消息数量
    state.msgtotalcount = value;
  }
}
//自定义触发mutations里函数的方法，context与store 实例具有相同方法和属性
const actions = {
  setTypeidAction(context,value){ //账户类型
    context.commit('setTypeid',value);
  },
  setMsgtotalcountAction(context,value){ //账户类型
    context.commit('setMsgtotalcount',value);
  }
}
const store = new Vuex.Store({
    state, // 挂载存取数据功能
    getters, //挂载数据计算功能
    mutations, // 挂载函数功能
    actions, // 挂载异步函数
    modules:{ // 挂载子模块仓库
      //暂无
    }
})
export default store


// WEBPACK FOOTER //
// ./src/router/store.js